<template>
  <div>
    <base-dialog fixed :show="isLoading" title="Loading...">
      <base-spinner><p>Authenthicating</p></base-spinner>
    </base-dialog>
    <base-dialog
      :show="!!error"
      @close="clearError"
      title="Failed to authenticate"
      >{{ error }}</base-dialog
    >
    <base-card>
      <form @submit.prevent="submitForm">
        <div class="form-control">
          <label for="email">Email Address:</label>
          <input type="email" v-model.trim="email" />
        </div>
        <div class="form-control">
          <label for="password">Password:</label>
          <input type="text" v-model.trim="password" />
        </div>
        <p class="invalid" v-if="!formIsValid">
          Invalid input!! Please check your email and password again.
        </p>
        <base-button type="submit">{{ submitButtonCaption }}</base-button>
        <base-button type="button" @click="switchMode">{{
          switchButtonCaption
        }}</base-button>
      </form>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formIsValid: true,
      email: '',
      password: '',
      mode: 'login',
      isLoading: false,
      error: null,
    };
  },
  computed: {
    submitButtonCaption() {
      if (this.mode === 'login') {
        return 'Login';
      } else {
        return 'Sign up';
      }
    },
    switchButtonCaption() {
      if (this.mode === 'login') {
        return 'Go to signup';
      } else {
        return 'Go to login';
      }
    },
  },
  methods: {
    switchMode() {
      if (this.mode === 'login') {
        this.mode = 'signup';
      } else {
        this.mode = 'login';
      }
    },
    async submitForm() {
      this.formIsValid = true;
      if (
        !this.email.includes('@') ||
        this.email === '' ||
        this.password.length < 6
      ) {
        this.formIsValid = false;
        return;
      }
      this.isLoading = true;

      try {
        if (this.mode === 'login') {
          await this.$store.dispatch('login', {
            email: this.email,
            password: this.password,
          });
        } else {
          await this.$store.dispatch('signup', {
            email: this.email,
            password: this.password,
          });
        }
        const redirectUrl ="/" +( this.$route.query.redirect || 'coaches')
        this.$router.replace(redirectUrl)
      } catch (error) {
        console.log(error);
        this.error =
          error.message ||
          'Failed to authenthicate. Please check your email and password again';
      }

      this.isLoading = false;
    },
    clearError() {
      this.error = null;
    },
  },
};
</script>
<style scoped>
form {
  margin: 1rem;
  border-radius: 12px;
  padding: 1rem;
}

.form-control {
  margin: 0.5rem 0;
}

label {
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: block;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.15rem;
}

input:focus,
textarea:focus {
  border-color: #3d008d;
  background-color: #faf6ff;
  outline: none;
}

.invalid {
  color: red;
  border: 1px solid red;
  padding: 5px;
}
</style>